import { AxiosResponse } from 'axios';
import RestAPI from 'components/Common/restApi';
import { Voicemail, UnlistenedVoicemailsCount } from './types';

interface UpdateParams {
  uuid: string;
  listened: boolean;
}

export default class VoicemailsApi {
  static update({ uuid, ...params }: UpdateParams): Promise<AxiosResponse<Voicemail>> {
    return RestAPI.updateWithFormData(`/alpha/voice/voicemails/${uuid}`, params);
  }

  static unlistenedCount(): Promise<AxiosResponse<UnlistenedVoicemailsCount>> {
    return RestAPI.get('/alpha/voice/voicemails/unlistened_count');
  }
}
